module.exports = __webpack_public_path__ + "static/img/ss14.5a3c1d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/farkle-safari/ss14.png
// module id = 31uM
// module chunks = 0